import type { ActionCandidate } from "../../../../../../types/candidate";
import type { LoopingStore } from "../../../../../../stores/automation/looping.store";

export const findWebhookAction = (
  looping: LoopingStore,
  allActions: ActionCandidate[],
): ActionCandidate | undefined => {
  const webhookActionInstanceId =
    looping.source?.oneofKind === "outputReference" &&
    looping.source.outputReference.source.oneofKind === "actionReference"
      ? looping.source.outputReference.source.actionReference.instanceId
      : looping.source?.oneofKind === "recordList" &&
          looping.source.recordList?.recordList?.oneofKind === "actionReference"
        ? looping.source.recordList.recordList.actionReference.instanceId
        : undefined;

  if (webhookActionInstanceId === undefined) {
    return undefined;
  }

  return allActions.find(
    (action) => action.actionReference?.instanceId === webhookActionInstanceId,
  );
};
